module.exports = __webpack_public_path__ + "img/entertainment-4.e5b9b681.jpg";